import { API, API_GET_ID } from "../../Config";

export const GetPremiumUser = () => {
  return API_GET_ID(API.PremiumUser);
};
